import { RootState } from "@store/reducers";
import { HiringCompanyType } from "@utils/constants";
import { useMemo } from "react";
import { useSelector } from "react-redux";
import { Navigate, Outlet, useLocation, useNavigate } from "react-router-dom";
import { hiringCompanySettingsTabs } from "./companyDetails.const";

const CompanyDetails: React.FC = () => {
  const { pathname } = useLocation();
  const navigate = useNavigate();
  const { user } = useSelector((state: RootState) => state.auth);
  const currentRole = Number(user?.hiringCompanyType);
  const canAccessAccountMembers =
    currentRole === HiringCompanyType.SUPER_ADMIN ||
    currentRole === HiringCompanyType.ADMIN ||
    currentRole === HiringCompanyType.MANAGER;

  const tabs = useMemo(() => {
    if (canAccessAccountMembers) return hiringCompanySettingsTabs;
    return hiringCompanySettingsTabs.filter(
      (tab) => tab.path !== "/settings/company-details/account-members",
    );
  }, [canAccessAccountMembers]);

  if (
    !canAccessAccountMembers &&
    pathname.includes("/settings/company-details/account-members")
  ) {
    return <Navigate to="/settings/company-details" replace />;
  }

  const activeTab = pathname;

  return (
    <div className="flex flex-1 flex-col md:flex-row mt-6 gap-6 h-full overflow-hidden">
      {/* Sidebar */}
      <div className="w-full md:w-64 shrink-0 border-r pr-1">
        <div className="rounded-md text-xs space-y-2">
          {tabs?.map((x) => (
            <div
            key={x?.path}
              onClick={() => navigate(x.path)}
              className={`px-4 py-3 cursor-pointer rounded-md ${
                activeTab === x.path
                  ? "bg-gray-100 font-medium"
                  : "text-gray-700 hover:bg-gray-50"
              }`}
            >
              {x.name}
            </div>
          ))}
        </div>
      </div>
      <div className="flex-1 flex w-[100%] min-h-0">
        <Outlet />
      </div>
    </div>
  );
};

export default CompanyDetails;
